import { PaymentType } from './../../../data/constants/payment-type.const';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'payment-selector',
  templateUrl: './payment-selector.component.html',
  styleUrls: ['./payment-selector.component.scss']
})
export class PaymentSelectorComponent implements OnInit {

  @Input() paymentKey: string;
  @Output() onPaymentSelection: EventEmitter<string> = new EventEmitter<string>();

  _PaymentType = PaymentType;
  _PaymentKeys = Object.keys(PaymentType);

  constructor() { }

  ngOnInit() {
    if (this.paymentKey !== PaymentType.MediacorpCredit.key) {
      this._PaymentKeys = this._PaymentKeys.filter(e => e !== PaymentType.MediacorpCredit.key)
    }
  }

  handleChange(type: string) {
    if (type !== this.paymentKey) {
      this.paymentKey = type;
      this.onPaymentSelection.emit(this.paymentKey);
    }
  }

}
